import Node from 'ln/node/Node';
import template from 'ln/template/TemplateManager';
import Lang from 'ln/lang/Lang';
import Course from './Course';
import CourseElement from './CourseElement';
import UserSequenceModel from '../models/UserSequenceModel';
import CustomUserSequenceModel from '../models/CustomUserSequenceModel';
import UserFileList from './UserFileList';


class Sequence extends CourseElement {

	
	public userFileList:UserFileList;
	
	constructor( public model:UserSequenceModel, private courseView: Course ) {
		super( model, courseView );
	}
	
	public init(){
		super.init();

		// userfile list
		this.userFileList = new UserFileList( this.model );
		this.userFileList.render();
		this.node.js( 'userfiles' ).append( this.userFileList.node );

		// listen for changes
		this.node.js( 'time' ).change.add( this.onTimeChange, this );
		this.node.js( 'notes' ).blur.add( this.onNoteChange, this );
		const done = this.node.js( 'done' );
		done.click.add( this.onDoneClicked, this );
		done.native.classList.toggle( '-checked', this.model.done );

		this.node.js('expand').click.add( () => {
			this.node.toggleClass( 'expanded' );
		});

		this.node.js( 'customize' ).click.add( this.customizeSequence, this );
		
		this.renderDisplayTime();

		this.blankLinks();

	}
	
	private onTimeChange( n:Node ){
		this.model.time = parseInt( n.value );
		this.model.save();
		
		// update round time button
		this.node.js( 'timeline-button' ).html = n.value + '\'';
		
		// update the course header
		this.courseView.rerenderComputedProperties();
		
		this.model.course.rerenderDisplayTime.dispatch();
	}
	
	/**
	 * Callback when the note has changed
	 */
	private onNoteChange( n:Node ) {
		this.model.note = n.html;
		this.model.save();
	}

	private onDoneClicked( n:Node ){
		this.model.done = !this.model.done;
		this.model.save();
		n.native.classList.toggle( '-checked' );
	}

	protected renderDisplayTime() {
		this.node.js('display-time').html = this.model.displayTime + ' ' + Lang.translate( 'processplan.time' );
	}

	private customizeSequence() {
		var model = new CustomUserSequenceModel( {
			origin: this.model.object().origin,
			title: this.model.title,
			module: this.model.module,
			time: this.model.time,
			done: this.model.done,
			method: ( this.model.get<Array<any>>( 'mhblinks' ).length == 0 ) ? this.model.method : this.getBookLinks( 'Methode', 'mhblinks' ),
			material: ( this.model.get<Array<any>>( 'fhblinks' ).length == 0 ) ? this.model.material : this.mergeMaterialAndFHBLinks(),
			userfiles: this.model.userfiles,
			modelName: "App\\CustomUserSequence"
		});
		
		model.backend = this.model.backend;
		
		model.save().then( function( model:CustomUserSequenceModel ) {
			model.course = this.model.course;
			model.userfiles = this.model.userfiles; // relation is not loaded on save, so add userfiles back

			// set origin with slides for slideview
			model.set( 'origin', this.model.object().origin );

			// remove listener on rerender display time on old model
			this.model.course.rerenderDisplayTime.remove( this.renderDisplayTime, this );

			// remove the old model and add the new one
			var index = this.model.course.sequences.index( this.model );
			this.model.course.sequences.add( model, index );
			this.model.course.sequences.removeAt( index + 1);

			// because of some sort of race condition, make shure relations are properly saved
			this.model.course.save();

		}.bind( this ) );
	}
	
	/**
	 * Function to concatenate all the mhb_links
	 */
	private getBookLinks( title:string, key:string ):string{
		var result = '';
		this.model.get<Array<any>>( key ).forEach( link => {
			result = result.concat( template.render( 'krw.lb-link', link ) );
		});
		return result;
	}

	/**
	 * Merge material and fhblinks
	 */
	private mergeMaterialAndFHBLinks():string{
		return this.model.material.concat( template.render( 'krw.lb-links', { title: Lang.translate( 'sequence.fb_link' ), links: this.model.get<Array<any>>( 'fhblinks' ) } ) );
		
	}
}

export default Sequence;